const LOCAL_STORAGE = {
  REDIRECT_TO: 'redirectTo'
}

export default LOCAL_STORAGE
